import React from "react";
import styled from "styled-components";
import { useLanguage } from '../../Context/LanguageContext';

export default function LessonHideSelectBox(props) {
  const { isHide, setIsHide } = props;
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <Button isClicked={!isHide} onClick={() => setIsHide(false)}>
        <Text fontFmaily={!isHide ? 'NotoSansKR-Medium' : 'NotoSansKR-Regular'} fontSize={14} color={!isHide ? '#FFFFFF' : '#000000'} cursor='pointer'>{t('system.public')}</Text>
      </Button>
      <Button isClicked={isHide} onClick={() => setIsHide(true)}>
        <Text fontFmaily={isHide ? 'NotoSansKR-Medium' : 'NotoSansKR-Regular'} fontSize={14} color={isHide ? '#FFFFFF' : '#000000'} cursor='pointer'>{t('system.private')}</Text>
      </Button>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 48%;
  height: 100%;

  border: ${props => props.isClicked ? '1px solid #FF8B48' : '1px solid #DFDFDF'};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? '#FF8B48' : '#FFFFFF'};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;